import React from "react";
import { useTranslation, Trans } from "react-i18next";

const ContactSection = ({
  name,
  phone,
  service,
  date,
  notes,
  onNameChange,
  onPhoneChange,
  onServiceChange,
  onDateChange,
  onNotesChange,
  onBook,
  onCall,
}) => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="contact">
      <h2>{t('contact.title')}</h2>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <input
          id="name"
          placeholder={t('contact.namePlaceholder')}
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
        />
        <input
          id="phone"
          placeholder={t('contact.phonePlaceholder')}
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: 12,
          flexWrap: "wrap",
          marginTop: 8,
        }}
      >
        <select
          id="service"
          value={service}
          onChange={(e) => onServiceChange(e.target.value)}
        >
          <option value="Consultation - Specific Problem">{t('contact.serviceOptions.consultation')}</option>
          <option value="Auspicious Date Selection">{t('contact.serviceOptions.dates')}</option>
          <option value="Marriage Match Analysis">{t('contact.serviceOptions.match')}</option>
        </select>
        <input
          id="date"
          type="date"
          value={date}
          onChange={(e) => onDateChange(e.target.value)}
        />
      </div>

      <textarea
        id="notes"
        rows={3}
        placeholder={t('contact.notesPlaceholder')}
        value={notes}
        onChange={(e) => onNotesChange(e.target.value)}
      />

      <div
        style={{
          display: "flex",
          gap: 8,
          marginTop: 8,
          flexWrap: "wrap",
        }}
      >
        <button id="bookBtn" className="btn" onClick={onBook}>
          {t('contact.sendWhatsapp')}
        </button>
        <button id="callBtn" className="btn ghost" onClick={onCall}>
          {t('contact.call')}
        </button>
      </div>

      <small style={{ color: "var(--muted)" }}>
        <Trans i18nKey="contact.offlineInfo">
          For offline sessions &amp; address, WhatsApp:{" "}
          <strong>+91 9486260006</strong>
        </Trans>
      </small>
    </section>
  );
};

export default ContactSection;
